import templateUrl from 'emun.swatch/swatches-table.htm';
import basicController from 'servicestack/basic.controller.properties';
import resolve from 'ioc/resolve';
import 'emun.swatch/swatches-table.client.scss';

let component = {
    bindings: {
    },
    require: {
        container: '^swatchContainer',
        list: '^swatches'
    },
    controller() {
        basicController(this);
        //this.query = this.list.query;
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;